<template>
  <div class="cold-humidity">
    <div id="hallwayChart" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      hallwayChart: null,
      hallwayChartOption: {},
      xAxisData: [],
      listData: []
    }
  },

  mounted() {
    var self = this;
    self.hallwayChart = charts.init(document.getElementById("hallwayChart"));
    self.queryData().then((res) => {
      self.initChart()
    })
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.statAvgTemperatureAndhumidity, { statType: "2" }).then(
          (res) => {
            if (res.success) {
              res.returnObj.forEach((item, index) => {
                this.listKeysList = [];
                this.xAxisData.push(item.hours);
                if (index == 0) {
                  for (let key in item.dataMap) {
                    this.listData.push({
                      name: key,
                      list: [],
                    });
                  }
                }
              });
              res.returnObj.forEach((item) => {
                for (let key in item.dataMap) {
                  this.listData = this.listData.map((el, inde) => {
                    let re = {
                      name: el.name,
                      list: [...el.list],
                    };
                    if (el.name === key) {
                      re.list.push(item.dataMap[key]);
                    }
                    return re;
                  });
                }
              });
              resolve(this.listData);
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      });
    },
    initChart() {
      const color = [
        "#00ADEF",
        "#FF6969",
        "#9BD342",
      ];
      const yDatas = [];
      const leftData = this.listData.slice(0, 3)
      leftData.forEach((item, index) => {
        yDatas.push({
          name: item.name,
          type: "line",
          lineStyle: {
            normal: {
              color: color[index],
              width: 2,
            },
          },
          data: item.list,
        });
      });
      const option = {
        color: color,
        legend: {
          icon: "rect",
          itemHeight: 6,
          itemWidth: 6,
          textStyle: {
            color: "#ffffff",
          },
          right: 0,
          top: 0,
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 22,
          bottom: 22,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            name: "时",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：℃",
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            nameTextStyle: {
              color: "#E4F5FD",
              fontSize: 12,
              lineHeight: 40,
              padding: [0, 0, 0, 30]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: yDatas,
      };
      this.hallwayChart = charts.init(document.getElementById("hallwayChart"));
      this.hallwayChart.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
.cold-humidity {
  height: 100%;
}
</style>